/** UMD's recordable marks (Testudo grading), ladder grades first.
 *
 *  Fallback for `InstitutionConfig.gradeMarks` when the backend/cached config
 *  predates W43 P3 (#275) or a component renders without the provider. Lives
 *  here (not in the context module) so test files that `jest.mock` the
 *  context still get a real list. Source of truth in production is
 *  `institution_config.grade_scale` via /api/institution/current.
 */
export const UMD_GRADE_MARKS: readonly string[] = [
  'A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F', 'XF',
  'P', 'CR', 'W', 'I',
];
